<h1 mat-dialog-title class="p-2 text-center"> {{title}} ?</h1>
<div class="row g-0">
    <mat-form-field class="col-12 px-3 mb-3">
        <input matInput [(ngModel)]="newText" [placeholder]="title">
    </mat-form-field>
    <button appPreventDoubleClick class="col-6 squared-flat-button" color="primary" mat-stroked-button (throttledClick)="onCancel()">
        Non
    </button>
    <button appPreventDoubleClick class="col-6 squared-flat-button" color="warn" mat-stroked-button (throttledClick)="onConfirm()">
        Oui
    </button>
</div>